'use strict';

/**
 * Sample Element Service
 */
module.service('productCategoryService', [ 'Restangular', '$q', function(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var productCategoryResource = Restangular.all('productcategory');

	return {

		searchProductCategories : function(filters) {
			var deferred = $q.defer();
			var answer = new restResponse();

			productCategoryResource.customGET('', filters).then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});
			return deferred.promise;
		},

		searchTree : function(filters) {
			var deferred = $q.defer();
			var answer = new restResponse();

			productCategoryResource.customGET('tree', filters).then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});
			return deferred.promise;
		},

		createProductCategory : function(createModel) {
			var deferred = $q.defer();
			var answer = new restResponse();

			productCategoryResource.post(createModel).then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});

			return deferred.promise;
		},

		loadProductCategory : function(id) {
			var deferred = $q.defer();
			var answer = new restResponse();
			productCategoryResource.get(id).then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});
			return deferred.promise;
		},

		updateProductCategory : function(id, updateModel) {
			var deferred = $q.defer();
			var answer = new restResponse();
			Restangular.one('productcategory', id).customPUT(updateModel).then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});
			return deferred.promise;
		},

		deleteProductCategory : function(id) {
			var deferred = $q.defer();
			var answer = new restResponse();
			Restangular.one('productcategory', id).remove().then(function(response) {
				answer.handleSuccessfullResponse(response, response.data);
				deferred.resolve(answer);
			}, function(response) {
				answer.handleErrorResponse(response, response.data);
				deferred.reject(answer);
			});
			return deferred.promise;
		},

	};
} ]);